import { render, staticRenderFns } from "./commercial-notices-list.vue?vue&type=template&id=29ee0a48&scoped=true&"
import script from "./commercial-notices-list.vue?vue&type=script&lang=js&"
export * from "./commercial-notices-list.vue?vue&type=script&lang=js&"
import style0 from "./commercial-notices-list.vue?vue&type=style&index=0&id=29ee0a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee0a48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ee0a48')) {
      api.createRecord('29ee0a48', component.options)
    } else {
      api.reload('29ee0a48', component.options)
    }
    module.hot.accept("./commercial-notices-list.vue?vue&type=template&id=29ee0a48&scoped=true&", function () {
      api.rerender('29ee0a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/commercial-notices/commercial-notices-list.vue"
export default component.exports